<template>
    <div>
        <div class="relative inline">
            <HeaderWaveIcon
                product="radioguide"
                position="left"
                style="will-change: opacity, transform"
                class="left-[-60%] top-[-25%]" />
            <svg
                viewBox="0 0 45 86"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                width="45"
                height="86"
                class="overflow-visible transition-transform duration-300 group-hover/menuItem:rotate-[10deg] group-hover/menuItem:animate-ring-radio group-hover/menuItem:drop-shadow-menu-item">
                <mask
                    id="path-1-inside-1_834_8460"
                    fill="white">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.21459 5.64586L2.21459 15.1605C1.33133 16.4469 0.814453 18.0046 0.814453 19.6831V77.7476C0.814453 82.1659 4.39618 85.7476 8.81446 85.7476H36.5055C40.9238 85.7476 44.5055 82.1659 44.5055 77.7476V19.683C44.5055 15.2648 40.9238 11.683 36.5055 11.683H25.3625C24.8749 10.6861 23.8506 9.99951 22.666 9.99951H21.666C20.4814 9.99951 19.4572 10.6861 18.9695 11.683H13.5073V5.64586C13.5073 2.52747 10.9793 -0.000488281 7.86094 -0.000488281C4.74255 -0.000488281 2.21459 2.52747 2.21459 5.64586Z" />
                </mask>
                <path
                    d="M2.21459 15.1605L3.86339 16.2925L4.21459 15.7809V15.1605H2.21459ZM2.21459 5.64586H0.214592H2.21459ZM25.3625 11.683L23.5659 12.5618L24.1143 13.683H25.3625V11.683ZM18.9695 11.683V13.683H20.2177L20.7661 12.5618L18.9695 11.683ZM13.5073 11.683H11.5073V13.683H13.5073V11.683ZM4.21459 15.1605L4.21459 5.64586H0.214592L0.214591 15.1605H4.21459ZM2.81445 19.6831C2.81445 18.4215 3.20158 17.2564 3.86339 16.2925L0.565792 14.0284C-0.538918 15.6375 -1.18555 17.5878 -1.18555 19.6831H2.81445ZM2.81445 77.7476V19.6831H-1.18555V77.7476H2.81445ZM8.81446 83.7476C5.50075 83.7476 2.81445 81.0613 2.81445 77.7476H-1.18555C-1.18555 83.2704 3.29161 87.7476 8.81446 87.7476V83.7476ZM36.5055 83.7476H8.81446V87.7476H36.5055V83.7476ZM42.5055 77.7476C42.5055 81.0613 39.8192 83.7476 36.5055 83.7476V87.7476C42.0284 87.7476 46.5055 83.2704 46.5055 77.7476H42.5055ZM42.5055 19.683V77.7476H46.5055V19.683H42.5055ZM36.5055 13.683C39.8192 13.683 42.5055 16.3693 42.5055 19.683H46.5055C46.5055 14.1602 42.0284 9.68304 36.5055 9.68304V13.683ZM25.3625 13.683H36.5055V9.68304H25.3625V13.683ZM22.666 11.9995C23.0579 11.9995 23.401 12.2247 23.5659 12.5618L27.1591 10.8043C26.3487 9.14748 24.6433 7.99951 22.666 7.99951V11.9995ZM21.666 11.9995H22.666V7.99951H21.666V11.9995ZM20.7661 12.5618C20.931 12.2247 21.2741 11.9995 21.666 11.9995V7.99951C19.6887 7.99951 17.9833 9.14748 17.1729 10.8043L20.7661 12.5618ZM13.5073 13.683H18.9695V9.68304H13.5073V13.683ZM11.5073 5.64586V11.683H15.5073V5.64586H11.5073ZM7.86094 1.99951C9.87477 1.99951 11.5073 3.63204 11.5073 5.64586H15.5073C15.5073 1.4229 12.0839 -2.00049 7.86094 -2.00049V1.99951ZM4.21459 5.64586C4.21459 3.63204 5.84712 1.99951 7.86094 1.99951V-2.00049C3.63798 -2.00049 0.214593 1.4229 0.214592 5.64586H4.21459Z"
                    fill="currentColor"
                    mask="url(#path-1-inside-1_834_8460)" />
                <rect
                    x="1.82617"
                    y="12.6831"
                    rx="7"
                    stroke="currentColor"
                    stroke-width="2"
                    width="41.6911"
                    height="72.0645" />
                <rect
                    x="6.49316"
                    y="19.3184"
                    rx="6"
                    stroke="currentColor"
                    stroke-width="2"
                    width="32.3686"
                    height="27.9026" />
                <rect
                    x="14.751"
                    y="28.3345"
                    rx="2"
                    stroke="currentColor"
                    stroke-width="2"
                    width="15.7568"
                    height="10.1494" />
                <rect
                    x="5.37305"
                    y="49.9121"
                    rx="4.19311"
                    stroke="currentColor"
                    stroke-width="2"
                    width="8.38622"
                    height="8.38622" />
                <rect
                    x="31.499"
                    y="49.9121"
                    rx="4.19311"
                    stroke="currentColor"
                    stroke-width="2"
                    width="8.38622"
                    height="8.38622" />
                <mask
                    id="path-8-outside-2_834_8460"
                    maskUnits="userSpaceOnUse"
                    x="14.0107"
                    y="49.6919"
                    fill="black"
                    width="18"
                    height="10">
                    <rect
                        fill="white"
                        x="14.0107"
                        y="49.6919"
                        width="18"
                        height="10" />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.0107 54.3398C16.0107 52.8774 17.1963 51.6919 18.6587 51.6919C18.9748 51.6919 19.2779 51.7473 19.559 51.8489C20.5911 52.222 21.5722 52.9381 22.6697 52.9381C23.7671 52.9381 24.7482 52.2221 25.7802 51.8491C26.0613 51.7475 26.3644 51.6921 26.6805 51.6921C28.1429 51.6921 29.3284 52.8776 29.3284 54.34C29.3284 55.8025 28.1429 56.988 26.6805 56.988C26.4148 56.988 26.1582 56.9489 25.9163 56.876C24.8297 56.5491 23.8041 55.8196 22.6694 55.8196C21.5348 55.8196 20.5093 56.5489 19.4228 56.8759C19.1809 56.9487 18.9244 56.9878 18.6587 56.9878C17.1963 56.9878 16.0107 55.8023 16.0107 54.3398Z" />
                </mask>
                <path
                    d="M18.6587 49.6919C16.0917 49.6919 14.0107 51.7728 14.0107 54.3398H18.0107C18.0107 53.982 18.3008 53.6919 18.6587 53.6919V49.6919ZM20.2389 49.968C19.743 49.7887 19.2099 49.6919 18.6587 49.6919V53.6919C18.7396 53.6919 18.8129 53.7058 18.8791 53.7298L20.2389 49.968ZM26.6805 49.6921C26.1293 49.6921 25.5962 49.7889 25.1003 49.9682L26.4601 53.7299C26.5263 53.706 26.5995 53.6921 26.6805 53.6921V49.6921ZM31.3284 54.34C31.3284 51.773 29.2475 49.6921 26.6805 49.6921V53.6921C27.0383 53.6921 27.3284 53.9822 27.3284 54.34H31.3284ZM26.6805 58.988C29.2475 58.988 31.3284 56.907 31.3284 54.34H27.3284C27.3284 54.6979 27.0383 54.988 26.6805 54.988V58.988ZM25.34 58.7912C25.7668 58.9197 26.2175 58.988 26.6805 58.988V54.988C26.6121 54.988 26.5496 54.978 26.4926 54.9609L25.34 58.7912ZM18.6587 58.9878C19.1217 58.9878 19.5723 58.9195 19.9991 58.791L18.8466 54.9607C18.7895 54.9778 18.727 54.9878 18.6587 54.9878V58.9878ZM14.0107 54.3398C14.0107 56.9068 16.0917 58.9878 18.6587 58.9878V54.9878C18.3008 54.9878 18.0107 54.6977 18.0107 54.3398H14.0107ZM22.6694 53.8196C21.6888 53.8196 20.8448 54.1341 20.2568 54.3798C19.5479 54.6761 19.2595 54.8364 18.8466 54.9607L19.9991 58.791C20.6726 58.5884 21.4402 58.2206 21.7993 58.0705C22.2794 57.8698 22.5155 57.8196 22.6694 57.8196V53.8196ZM22.6697 54.9381C23.6431 54.9381 24.4727 54.6209 25.0567 54.3633C25.7905 54.0396 26.0088 53.8931 26.4601 53.7299L25.1003 49.9682C24.5196 50.1781 23.7314 50.5761 23.4423 50.7036C23.0034 50.8972 22.7938 50.9381 22.6697 50.9381V54.9381ZM26.4926 54.9609C26.0796 54.8366 25.7912 54.6763 25.0822 54.3799C24.4942 54.1342 23.6501 53.8196 22.6694 53.8196V57.8196C22.8234 57.8196 23.0594 57.8698 23.5396 58.0705C23.8988 58.2206 24.6664 58.5885 25.34 58.7912L26.4926 54.9609ZM18.8791 53.7298C19.3304 53.8929 19.5487 54.0395 20.2826 54.3632C20.8666 54.6209 21.6963 54.9381 22.6697 54.9381V50.9381C22.5457 50.9381 22.3361 50.8972 21.8971 50.7035C21.608 50.576 20.8197 50.1779 20.2389 49.968L18.8791 53.7298Z"
                    fill="currentColor"
                    mask="url(#path-8-outside-2_834_8460)" />
                <path
                    d="M31.666 12.9995L33.666 12.9995C33.666 13.5518 33.2183 13.9995 32.666 13.9995C32.1137 13.9995 31.666 13.5518 31.666 12.9995Z"
                    stroke="currentColor"
                    stroke-width="1.5" />
            </svg>
            <HeaderWaveIcon
                product="radioguide"
                position="right"
                class="left-[30%] top-[-25%]" />
        </div>
    </div>
</template>

<script setup lang="ts">
import HeaderWaveIcon from '~/components/layouts/header/svg/HeaderWaveIcon.vue'
</script>
